// extracted by mini-css-extract-plugin
export default {"InlineRecentResults":"pA_pB","slideOutRight":"pA_pC"};